import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { Form, FormGroup, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik } from "formik";
import SvgImage from "../Icons/Icons";
import { DatePickerField } from "../core/inputs/input";

import { getTripDelayReasons, getLast7Trips, getTripIdleReasons,getLast7IdleTrips, getTripDataCount, getAssignVehicleCount} from "../../services/Store/Actions/TripsAction";

import { getVehicleListAction } from "../../services/Store/Actions/manageVehicleAction";
import { getDriverList } from "../../services/Store/Actions/driverslistActions";
import moment from "moment";
import {
  removeItemFromAsyncStorage,
  storeDataToAsyncStorage,
} from "../../services/Utils/functions";
import { Button } from "reactstrap";
import Switch from "react-switch";
import { PieChart } from '@mui/x-charts/PieChart';
import { LineChart } from "@mui/x-charts";
import { Paper } from "@material-ui/core";
import { makeStyles } from '@mui/styles';
import ShowExcelV3 from "../Modals/showExcelV3";
import { getBranch } from "../../services/Store/Actions/UserManagementAction";

function TripAnalysis(props) {
  const { sideBar } = props;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
 
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tripAnalysis, setTripAnalysis] = useState(true)
  const toggleTripAnalysis = () => {
    setTripAnalysis(!tripAnalysis)
    navigate('/trips')
  }
  const [fleetIdTemp, setFleetIdTemp] = useState("");
  const [driverIdTemp, setDriverIdTemp] = useState("");
  const [startDate, setStartdate] = useState("");
  const [endDate, setEndDate] = useState("");

  const datepickerRefEnd = useRef();
  const datepickerRefStart = useRef();
  const [open, setOpen] = useState(false);
  const [openDriver, setOpenDriver] = useState(false);

  const [search, setSearch] = useState("");
  const [searchDriver, setSearchDriver] = useState("");

  const [showExcel, setShowExcel] = useState(false);
  const [fileData, setFileData] = useState(false);
  const [searchBranch, setSearchBranch] = useState("");
  const [open2, setOpen2] = useState(false);
  const [branchId, setBranchId] = useState("");

  const allFleets = useSelector(
    (state) => state?.manageVehicle?.allFleets?.rows
  );

  console.log("ffdfdfdfdfd", allFleets);
  const vehCount = useSelector(
    (state) => state?.manageVehicle?.allFleets?.count
  );

  const driverList = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.rows
  );
  const driverCount = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.count
  );
  const tripDelayReasons = useSelector(
    (state) => state?.trip?.tripDelayReasons
  );
  const lastSevenTrips = useSelector(
    (state) => state?.trip?.lastSevenTrips
  );
  const tripIdleReasons = useSelector(
    (state) => state?.trip?.tripIdleReasons
  );
  const lastSevenIdleTrips = useSelector(
    (state) => state?.trip?.lastSevenIdleTrips
  );
  const 
    getAssignVehicleData = useSelector(
      (state) => state?.trip?.getAssignVehicle
    );
    const tripstatusData = useSelector(
      (state) => state?.trip?.tripstatusData
    );
    const branchList = useSelector(
      (state) => state?.userManagement?.branchData.rows
    );
  const handleClickDatepickerIcon2 = () => {
    const datepickerElement = datepickerRefEnd.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  const handleClickDatepickerIcon1 = () => {
    const datepickerElement = datepickerRefStart.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };

  
  useEffect(() => {
    dispatch(
      getVehicleListAction({
        offset: "",
        search: search,
        minKyc: "",
        sortAs: "",
        sortBy: "",
        limit: 10,
      })
    );
  }, [search]);

  useEffect(() => {
    dispatch(
      getDriverList({
        offset: "",
        search: searchDriver,
        minKyc: "",
        sortAs: "",
        sortBy: "",
        limit: 10,
      })
    );
  }, [searchDriver]);

  useEffect(() => {
    console.log("jijijr", searchBranch);
    let timeout;
    if (searchBranch == "") {
      dispatch(
        getBranch({
          offset: "",
          search: searchBranch,
          minKyc: "",
          sortAs: "",
          sortBy: "",
          limit: 10,
        }, ()=>{})
      );
    } else {
      timeout = setTimeout(() => {
        dispatch(
          getBranch({
            offset: "",
            search: searchBranch,
            minKyc: "",
            sortAs: "",
            sortBy: "",
            limit: 10,
          }, (res) => {console.log(res?.data)})
        );
      }, 250);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [searchBranch]);


  useEffect(()=> {
    dispatch(
      getTripDelayReasons({
        fleetId: fleetIdTemp,
        startDate: startDate,
        endDate: endDate,
        driverUserId: driverIdTemp
      }, (res) => {console.log('getTripDelayReasons222', res?.data)})
    )
  }, [fleetIdTemp,startDate,endDate,driverIdTemp])
  useEffect(()=> {
    dispatch(
      getLast7Trips({
        fleetId: fleetIdTemp,
        startDate: startDate,
        endDate: endDate,
        driverUserId: driverIdTemp
      }, (res) => {console.log('getLast7Trips', res?.data)})
    )
  },[fleetIdTemp,startDate,endDate,driverIdTemp])
  useEffect(()=> {
    dispatch(
      getTripIdleReasons({
        fleetId: fleetIdTemp,
        startDate: startDate,
        endDate: endDate,
        driverUserId: driverIdTemp
      }, (res) => {console.log('getTripIdleReasons', res?.data)})
    )
  }, [fleetIdTemp,startDate,endDate,driverIdTemp])
  useEffect(()=> {
    dispatch(
      getLast7IdleTrips({
        fleetId: fleetIdTemp,
        startDate: startDate,
        endDate: endDate,
        driverUserId: driverIdTemp
      }, (res) => {console.log('getLast7IdleTrips', res?.data)})
    )
  },[fleetIdTemp,startDate,endDate,driverIdTemp])


  useEffect(()=> {
    dispatch(
      getTripDataCount({branchId : branchId
      }, (res) => {console.log('tripstatusData', res?.data)})
    )
  },[branchId])

  useEffect(()=> {
    dispatch(
      getAssignVehicleCount({branchId : branchId
      }, (res) => {console.log('getAssignVehicle', res?.data)})
    )
  },[branchId])

  console.log(tripDelayReasons,'tripDelayReasonstripDelayReasons');
  console.log(tripIdleReasons,'tripIdleReasonstripIdleReasons');
  console.log(lastSevenIdleTrips,'lastSevenIdleTripslastSevenIdleTrips');

const data = tripDelayReasons.map((elem,i) => {
  return {
    id: i,
    label: elem?.delayedReason,
    value: elem?.Num_Trips,
    Avg_Delayed: (parseFloat(elem?.Avg_Delayed)/60).toFixed(2),
    Maximum_Delayed: (elem?.Maximum_Delayed/60).toFixed(2),
    Minimum_Delayed: (elem?.Minimum_Delayed/60).toFixed(2),
    padAngle: 2
  }
})

const data1 = [{id: 1,label : "unAssign",value : getAssignVehicleData?.unAssign},{id: 2,label : "assign",value : getAssignVehicleData?.assign}]
const data2 = tripstatusData?.map((element,i) => {
  return {
    id: i,
    label:element?.status,
    value: element?.count,
    data : element?.data,
  };
})

console.log(lastSevenTrips,"datadatadatadata1111");

const delayMinutes = lastSevenTrips.map(elem => (elem?.Delayed_Time_in_Minutes/60).toFixed(2))
const lastTrips = lastSevenTrips.map(elem => elem?.tripNo)

const useStyles = makeStyles({
  root: {  
      padding: 8,
      backgroundColor: '#FBECE4',
      }
  
});
const CustomItemTooltipContent = (props) => {
  const { itemData, series } = props;
  console.log('CustomItemTooltipContentCustomItemTooltipContent',itemData,series);
  const classes = useStyles();
  return (
    <Paper outlined className={classes.root} >
      <p>{series.label}</p>
      <p>Count: {series.data[itemData.dataIndex].value}</p>
      <p>Avg_Delayed: {series.data[itemData.dataIndex].Avg_Delayed}  Hours</p>
      <p>Maximum_Delayed: {series.data[itemData.dataIndex].Maximum_Delayed} Hours</p>
      <p>
      Minimum_Delayed: {series.data[itemData.dataIndex].Minimum_Delayed} Hours
      </p>
    </Paper>
  );
};

const CustomItemTooltipContent1 = (props) => {
  const { itemData, series } = props;
  console.log('CustomItemTooltipContentCustomItemTooltipContent',itemData,series);
  const classes = useStyles();
  return (
    <Paper outlined className={classes.root} >
      <p>{series.label}</p>
      <p>Count: {series.data[itemData.dataIndex].value}</p>
    </Paper>
  );
};

const CustomItemTooltipContent2 = (props) => {
  const { itemData, series } = props;
  console.log('CustomItemTooltipContentCustomItemTooltipContent',itemData,series);
  const classes = useStyles();
  return (
    <Paper outlined className={classes.root} >
      <p>{series?.data[itemData?.dataIndex]?.label}</p>
      <p>Count: {series?.data[itemData?.dataIndex].value}</p>
    </Paper>
  );
};

  return (
    <div
      className="container topMargin sideBarMargin"
      style={{
        // paddingTop:"5.5rem",
        marginLeft: sideBar ? "220px" : "100px",
        maxWidth: sideBar ? windowWidth - 240 : windowWidth - 130,
      }}
    >
      <div
        className="main1"
        style={{ height: "1200px", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", flexDirection:"row", justifyContent:"space-between" }}>
          <div>
            <h1 className="headingLow semiBold" style={{ marginBottom: "25px" }}>
              Trips
            </h1>
          </div>
          <div style={{ display: "flex", flexDirection:"row", justifyContent:"space-between" }}>
            <div style={{ paddingTop: "3px" }}>
              <Switch
                  checked={tripAnalysis}
                  onChange={toggleTripAnalysis}
                  onColor="#EBF2F2"
                  onHandleColor="#2E7C7B"
                  handleDiameter={10}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  height={10}
                  width={25}
                  id="material-switch"
                />
            </div>
            <h1 className="headingLow semiBold" style={{ marginLeft: "15px" }}>
              Analysis
            </h1>
          </div>
        </div>
        <div>
        <Formik
          enableReinitialize
          initialValues={{
            vrn: "",
            driver: "",
            startDate: "",
            endDate: "",
          }}
          onSubmit={(values, actions) => {
            console.log("sdsadsad", values);
            actions.resetForm();
          }}
        >
          {({
            handleBlur,
            handleChange,
            handleSubmit,
            values,
            touched,
            isValid,
            errors,
            setFieldValue,
            resetForm,
          }) => (
            <Form onSubmit={handleSubmit}>
              <FormGroup
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "50px",
                }}
              >
                <FormGroup>
                  <label for="vrn" className="heading3 semiBold">
                    Vehicle No:
                  </label>
                  <div
                    // onClick={() => {
                    //   setOpen(true);
                    // }}
                    className="custNamepadd3"
                  >
                    <input
                      className={`inputBoxCust1 ${
                        touched.amount && errors.amount ? "is-invalid" : ""
                      }`}
                      type="text"
                      id="vrn"
                      name="vrn"
                      touched={touched.vrn}
                      errors={errors.vrn}
                      // onBlur={handleBlur("vrn")}
                      onChange={(event) => {
                        setOpen(true);
                        setSearch(event.target.value);
                        setFieldValue("vrn", event.target.value, true);
                        if (!event.target.value) {
                          setFleetIdTemp("");
                        }
                      }}
                      value={values.vrn}
                      // autoFocus
                      placeholder="Select Vehicle"
                      autocomplete="off"
                      onFocus={() => {
                        setOpen(true);
                      }}
                      onBlur={() => {
                        setOpen(false);
                      }}
                      // placeholder="Enter Vechicle No"
                    />
                  </div>
                  <div style={{ position: "relative" }}>
                    {open ? (
                      <div
                        className="driverSearchContainer containerShadow"
                        style={{
                          width: "100%",
                          marginTop: "5px",
                          borderRadius: "8px",
                          border: "1px solid #E2E2E2",
                        }}
                      >
                        {/* <div
                          style={{
                            position: "absolute",
                            top: "0.3rem",
                            right: "0.5rem",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setOpen(false);
                          }}
                        >
                          <SvgImage name="CloseButtonLogo" />
                        </div> */}
                        {allFleets?.map((item, i) => {
                          return (
                            <>
                              {/* {item?.Fastag !== null ? ( */}
                              <div
                                key={i}
                                className="flexStyling padding8 "
                                onClick={(event) => {
                                  setOpen(false);
                                  // setUserId(event.target.value);
                                  setFieldValue("vrn", item?.regNumber, true);
                                  setFieldValue("fleetId", item?.fleetId, true);
                                  setFleetIdTemp(item?.fleetId);
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                <input
                                  type="radio"
                                  name="vrn"
                                  value={item?.fleetId}
                                  id={item?.fleetId}
                                />
                                <div
                                  className="padding16L"
                                  value={item?.fleetId}
                                >
                                  {item?.regNumber}
                                </div>
                              </div>
                              {/* ) : (
                                    <></>
                                  )} */}
                            </>
                          );
                        })}
                        {vehCount == 0 ? (
                          <div className="heading3 semiBold padding16 padding24B">
                            No Vehicle Available
                          </div>
                        ) :(
                          <></>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </FormGroup>
                <FormGroup>
                  <label for="driver" className="heading3 semiBold">
                    Driver
                  </label>
                  <div
                    // onClick={() => {
                    //   setOpenDriver(true);
                    // }}
                    className="custNamepadd3"
                  >
                    <input
                      className={`inputBoxCust1 ${
                        touched.amount && errors.amount ? "is-invalid" : ""
                      }`}
                      type="text"
                      id="driver"
                      name="driver"
                      touched={touched.driver}
                      errors={errors.driver}
                      // onBlur={handleBlur("driver")}
                      onChange={(event) => {
                        setOpenDriver(true);
                        setSearchDriver(event.target.value);
                        setFieldValue("driver", event.target.value, true);
                        if (!event.target.value) {
                          setDriverIdTemp("");
                        }
                      }}
                      value={values.driver}
                      // autoFocus
                      placeholder="Select Driver"
                      autocomplete="off"
                      onFocus={() => {
                        setOpenDriver(true);
                      }}
                      onBlur={() => {
                        setOpenDriver(false);
                      }}
                    />
                  </div>

                  <div style={{ position: "relative" }}>
                    {openDriver ? (
                      <div
                        className="driverSearchContainer containerShadow"
                        style={{
                          width: "100%",
                          marginTop: "5px",
                          borderRadius: "8px",
                          border: "1px solid #E2E2E2",
                        }}
                      >
                        {/* <div
                          style={{
                            position: "absolute",
                            top: "0.3rem",
                            right: "0.3rem",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setOpenDriver(false);
                          }}
                        >
                          <SvgImage name="CloseButtonLogo" />
                        </div> */}
                        {driverList?.map((item, i) => {
                          return (
                            <>
                              {item?.Fastag !== null ? (
                                <div
                                  key={i}
                                  className="flexStyling padding8 "
                                  onClick={(event) => {
                                    setOpenDriver(false);
                                    // setUserId(event.target.value);
                                    setFieldValue(
                                      "driver",
                                      item?.User?.fullName,
                                      true
                                    );
                                    setFieldValue(
                                      "userId",
                                      event.target.value,
                                      true
                                    );

                                    setDriverIdTemp(item?.User?.userId);
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  <input
                                    type="radio"
                                    name="driver"
                                    value={item?.User?.userId}
                                    id={item?.User?.userId}
                                  />
                                  <div className="padding16L">
                                    {item?.User?.fullName.length > 35
                                      ? item?.User?.fullName.split(0, 35) +
                                        "..."
                                      : item?.User?.fullName}
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </>
                          );
                        })}
                        {driverCount == 0 ? (
                          <div className="heading3 semiBold padding16 padding24B">
                            No driver Available
                          </div>
                        ) : driverCount == undefined ? (
                          <div className="heading3 semiBold padding16 padding24B">
                            No driver Available
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                    <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                      {errors.userId && touched.userId ? (
                        <div>*{errors.userId}</div>
                      ) : null}
                    </div>
                  </div>
                </FormGroup>
                <FormGroup>
                        <label for="vrn" className="heading3 semiBold">
                          Branch:
                        </label>
                        <div
                          className="custNamepadd3"
                        >
                          <input
                            className={`inputBoxCust1 form-control-1 ${
                              touched.branch && errors.branch
                                ? "is-invalid"
                                : ""
                            }`}
                            type="text"
                            id="branch"
                            name="branch"
                            touched={touched.branch}
                            errors={errors.branch}
                            // onBlur={() => {
                            //   handleBlur("branch");
                            //   setOpen2(false);
                            // }}
                            onClick={() => {
                              setOpen2(!open2);
                            }}
                            autoComplete="off"
                            onChange={(event) => {
                              console.log("kkjjsss", event.target.value);
                              setOpen2(true);
                              setSearchBranch(event.target.value);
                              setFieldValue("branchName", event.target.value, true);
                            }}
                            value={values.branchName}
                            // onFocus={(e) => {
                            //   setOpen2(true);
                            // }}
                            placeholder="Select Branch"
                            disabled={
                              values?.isDummy == 2 || values?.isDummy == "0"
                                ? true
                                : false
                            }
                          />
                          {console.log(
                            "values.branch.branch",
                            values?.branchId
                          )}
                        </div>
                        <div style={{ position: "relative" }}>
                          {open2 ? (
                            <div className="driverSearchContainer containerShadow">
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0.3rem",
                                  right: "0.3rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  console.log("herecomming....");
                                  setBranchId("")
                                  setOpen2(false);
                                  setFieldValue("branchName", "", true );
                                }}
                              >
                                <SvgImage name="CloseButtonLogo" />
                              </div>
                              {console.log("branchList",branchList)}
                              { branchList?.length != 0  ? branchList?.map((item, i) => {
                                return (
                                  <>
                                  {console.log("itemitem",item)}
                                   
                                      <div
                                        key={i}
                                        className="flexStyling padding8 "
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={(event) => {
                                          setBranchId(item?.branchId)
                                          setFieldValue(
                                            "branchName",
                                            item?.branchName,
                                            true
                                          );
                                          setFieldValue(
                                            "branchId",
                                            item?.branchId,
                                            true
                                          );
                                          setOpen2(false);
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="driver"
                                          value={item?.branchId}
                                          id={item?.branchId}
                                        />
                                        <div className="padding16L">
                                          {item?.branchName}
                                        </div>
                                      </div>
                                  </>
                                );
                              }):
                              (
                                <div className="heading3 semiBold padding16 padding24B">
                                  No Branch Available
                                </div>
                              )}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                  </FormGroup>
                <button
                  className="greenButton"
                  style={{ width: "160px" }}
                  type="button"
                  onClick={() => {
                    setDriverIdTemp("");
                    setSearchDriver("");
                    setFleetIdTemp("");
                    setStartdate("");
                    setEndDate("");
                    resetForm();
                  }}
                >
                  Clear Filter
                </button>
              </FormGroup>

              <FormGroup
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "50px",
                }}
              >
                <FormGroup>
                  <label for="startDate" className="heading3 semiBold">
                    Start Date
                  </label>
                  <div className="custNamepadd3 row" style={{ width: "200px" }}>
                    <div className="col-9">
                      <DatePickerField
                        classname="searchBar-input1"
                        name="startDate"
                        header="Select Start date"
                        value={values.startDate}
                        onChange={(v) => {
                          setFieldValue("startDate", v, true);
                          setStartdate(v);
                        }}
                        //onChange={(v) => setFieldValue("endDate", v, true)}
                        maxDate={values.endDate === "" ? "" : values.endDate}
                        // maxDate={new Date()}
                        ref1={datepickerRefEnd}
                        style={{ width: "100px" }}
                      />
                    </div>
                    <div className="col-3">
                      <label
                        className="date-input"
                        for="startDate"
                        style={{
                          position: "relative",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickDatepickerIcon2();
                        }}
                      >
                        <SvgImage
                          name="CalenderLogo"
                          width="32"
                          height="32"
                          // classname="date-logo"
                        />
                      </label>
                    </div>
                  </div>
                  <div
                    className="heading4 Regular"
                    style={{ margin: "7px 0 0px 0", color: "red" }}
                  >
                    {errors.endDate && touched.endDate ? (
                      <div>*{errors.endDate}</div>
                    ) : null}
                  </div>
                  {/* <label for="vrn" className='heading3 semiBold'>
                      Start Date
                    </label> */}
                  {/* <input
                      type="text"
                      id="vrn"
                      className={`form-control-1 ${touched.amount && errors.amount ? "is-invalid" : ""
                        }`}
                      name="vrn"
                      // onChange={handleChange("amount")}
                      value={values.amount}
                      // onBlur={() => {
                      //   dispatch(
                      //     sendAnalitics("Enter_Amt_Web", {
                      //       upi_netBank_amount: values.amount,
                      //     })
                      //   );
                      //   handleBlur("amount");
                      // }}
                      touched={touched.amount}
                      errors={errors.amount}
                      placeholder="Select Start Date"
                    /> */}
                </FormGroup>
                <FormGroup>
                  <label for="endtDate" className="heading3 semiBold">
                    End Date
                  </label>
                  <div className="custNamepadd3 row" style={{ width: "200px" }}>
                    <div className="col-9">
                      <DatePickerField
                        classname="searchBar-input1"
                        name="endtDate"
                        header="Select End date"
                        value={values.endDate}
                        onChange={(v) => {
                          setFieldValue("endDate", v, true);
                          setEndDate(v);
                        }}
                        //onChange={(v) => setFieldValue("endDate", v, true)}
                        minDate={
                          values.startDate === "" ? "" : values.startDate
                        }
                        // maxDate={new Date()}
                        ref1={datepickerRefStart}
                        style={{ width: "100px" }}
                      />
                    </div>
                    <div className="col-3">
                      <label
                        className="date-input"
                        for="endDate"
                        style={{
                          position: "relative",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickDatepickerIcon1();
                        }}
                      >
                        <SvgImage
                          name="CalenderLogo"
                          width="32"
                          height="32"
                          // classname="date-logo"
                        />
                      </label>
                    </div>
                  </div>
                  <div
                    className="heading4 Regular"
                    style={{ margin: "7px 0 0px 0", color: "red" }}
                  >
                    {errors.endDate && touched.endDate ? (
                      <div>*{errors.endDate}</div>
                    ) : null}
                  </div>
                  {/* <label for="vrn" className='heading3 semiBold'>
                      Start Date
                    </label> */}
                  {/* <input
                      type="text"
                      id="vrn"
                      className={`form-control-1 ${touched.amount && errors.amount ? "is-invalid" : ""
                        }`}
                      name="vrn"
                      // onChange={handleChange("amount")}
                      value={values.amount}
                      // onBlur={() => {
                      //   dispatch(
                      //     sendAnalitics("Enter_Amt_Web", {
                      //       upi_netBank_amount: values.amount,
                      //     })
                      //   );
                      //   handleBlur("amount");
                      // }}
                      touched={touched.amount}
                      errors={errors.amount}
                      placeholder="Select Start Date"
                    /> */}
                </FormGroup>
              </FormGroup>
            </Form>
          )}
        </Formik>
        </div>
        <div className="row">
          <div className="col-6">
          <h5>Delayed Reasons</h5>
          <PieChart
            margin={{top: 50, right: 200}}
            tooltip={{trigger: 'item',itemContent: CustomItemTooltipContent}}
            series={[
              {
                data: data,
                innerRadius: 50,
                // outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                // color: ""
                // startAngle: -90,
                // endAngle: 180,
              }
            ]}
            width={500}
            height={250}
          />
          </div>
          <div className="col-6">
            <h5 >Last 7 Trips Delays</h5>
            <LineChart
              tooltip={{trigger: 'none',}}
              series={[
                {
                  data: delayMinutes,
                  label: 'Delay (Hours)'
                },
              ]}
              xAxis={[{ scaleType: 'point', data: lastTrips, label: 'Trip No' }]}
              width={600}
              height={300}
            />
          </div>
          <div className="col-6">
          <h5>Assign Vehicle</h5>
          <PieChart
            margin={{top: 50, right: 200}}
            tooltip={{trigger: 'item',itemContent: CustomItemTooltipContent1}}
            series={[
              {
                data: data1,
                innerRadius: 50,
                // outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                // color: ""
                // startAngle: -90,
                // endAngle: 180,
              }
            ]}
            width={500}
            height={250}
          />
          </div>

          <div className="col-6">
          <h5>Trip Vehicle Stats</h5>
          <PieChart
            margin={{top: 50, right: 200}}
            tooltip={{trigger: 'item',itemContent: CustomItemTooltipContent2}}
            series={[
              {
                data: data2,
                innerRadius: 50,
                // outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                // color: ""
                // startAngle: -90,
                // endAngle: 180,
              }
            ]}
            onItemClick={(event, d) => {
              setShowExcel(true)
              setFileData(data2[d?.dataIndex]?.data)
            }}
            width={500}
            height={250}
          />
    </div>
        </div>
        {/* <div style={{ display: "flex", flexDirection:"row", justifyContent:"space-between" }}>
          <div >
          <h5>Idle Reasons</h5>
          <PieChart
            margin={{top: 50, right: 200}}
            tooltip={{trigger: 'item',itemContent: CustomItemTooltipContent}}
            series={[
              {
                data: data,
                innerRadius: 50,
                // outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                // startAngle: -90,
                // endAngle: 180,
               
              }
            ]}
            width={500}
            height={250}
          />
          </div>
          <div>
            <h5 >Last 7 Idle Trips</h5>
            <LineChart
              tooltip={{trigger: 'none',}}
              series={[
                {
                  data: delayMinutes,
                  label: 'Delay (Hours)'
                },
              ]}
              xAxis={[{ scaleType: 'point', data: lastTrips, label: 'Trip No' }]}
              width={600}
              height={300}
            />
          </div>
        </div> */}
      </div>
      {
        showExcel ? <ShowExcelV3
        toggle={() => setShowExcel(!showExcel)}
        modal={showExcel}
        setModal={setShowExcel}
        noramlData={fileData}
        type="tripView"
      /> : <></>
      }
    </div>
  );
}

export default TripAnalysis;
